import * as React from 'react';
import { BooleanInput, Create, FormDataConsumer, ImageInput, required, SimpleForm, TextInput, useTranslate } from 'react-admin';
import { ToggleButtonGroup } from '@mui/material';
import { transformMediaUrlInput } from '../../lib/media/makeUrl';
import { ServiceImageField } from '../../components/Field/ServiceImageField';
import { isUrlValid } from '../../lib/media/isValidUrl';
import { RichTextInput } from '../../components/RichTextJsonInput';
import { ClearButtons, LevelSelect, LinkButtons, ListButtons, RichTextInputToolbar } from 'ra-input-rich-text';
import { HorizontalRuleButton } from '../../components/HorizontalRuleButton';
import { CustomFormatButtons } from '../../components/FormatButtons';
import { ImageButton } from '../../components/ImageButton';
import { LinkContentButton } from '../../components/LinkContentButton';
import { LinkFileButton } from '../../components/LinkFileButton';
import { VideoButton } from '../../components/VideoButton';
import NewsResource from '../News/NewsResource';
import { withUpload } from '../../lib/withUpload';

let urlValid = false;

const urlExists = (url:string) => {
  if (url)
    return urlValid ? undefined : 'lto.generic.url_notfound';
  else 
    return undefined;
}

const rules = {
  name: [required()],
  imageurl: [required(), isUrlValid, urlExists],
  image: [required()],
};

export const SectorCreate = (props: any) => {
  const translate = useTranslate();
  const transform = data => ({
    ...data,
    mediaUrl: transformMediaUrlInput(data.mediaUrl)
  });
  return(
    <Create {...props} transform={transform}>
      <SimpleForm defaultValues={withUpload('mediaId', 'media')}>
        <TextInput source="name" validate={rules.name} />
        <BooleanInput source="useMediaUrl" />
        <FormDataConsumer>
          {({ formData, ...rest }) => {
            const displayurl = transformMediaUrlInput(formData.mediaUrl)
            return formData.useMediaUrl ? (
                <>
                  <TextInput source="mediaUrl" placeholder='mediaUrl' validate={rules.imageurl} />
                  {formData.mediaUrl ? <img style={{ marginBottom: '14px'}} onError={() => urlValid = false} onLoad={() => urlValid = true} src={`${displayurl}${displayurl.includes('?') ? '&' : '?'}width=48&height=48`} width={48} height={48} alt={formData.mediaUrl} /> : null}
                </>
              ) : (
                <ImageInput
                  source="media"
                  label={false}
                  accept="image/png, image/jpeg, image/webp"
                  validate={rules.image}
                  placeholder={<p>{translate('lto.upload_label')}</p>}
                  helperText={'resources.news.imageHelperText'}
                >
                  <ServiceImageField source="media" sortable={false} />
                </ImageInput>
              )
            }
          }
        </FormDataConsumer>
        <RichTextInput
          source="content"
          contentType="json"
          toolbar={
            <RichTextInputToolbar>
              <LevelSelect />
              <HorizontalRuleButton />
              <CustomFormatButtons />
              <ListButtons />
              <ToggleButtonGroup>
                <LinkButtons />
                <LinkContentButton resource={NewsResource.name}  />
                <LinkFileButton allowed={['application/msword', 'application/msexcel', 'application/pdf', 'text/plain', 'application/vnd.ms-powerpoint']} />
              </ToggleButtonGroup>
              <ToggleButtonGroup>
                <ImageButton />
                <VideoButton />
              </ToggleButtonGroup>
              <ClearButtons />
            </RichTextInputToolbar>
          }
        />
      </SimpleForm>
    </Create>
  );
}